import * as Types from '../types'

export const setSideMenuVisibility = ({ visible = false }) => {
    return {
        type: Types.SIDE_MENU_VISIBILITY_UPDATE,
        visible,
    }
}
